import DownloadReport from '@/components/Grid/Renderers/DownloadReport';
import { columnTypes as defaultColumnTypes } from '@/services/Grid/ColumnTypes';
import ShowPhotos from '@/components/Grid/Renderers/ShowPhotos';
import TooltipComponent from '@/components/Grid/Renderers/TooltipComponent.vue';
import PropertyAssessmentType from "@/services/Property/PropertyAssessmentType";

export const gridDefaultColDef = {
  resizable: true,
  sortable: true,
  filter: 'agSetColumnFilter',
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const columnTypes = defaultColumnTypes;

export const gridColumns = [
  {
    headerName: 'Assessment Type',
    field: 'assessmentType',
    width: 160,
    minWidth: 160,
    filter: 'agSetColumnFilter',
  },
  {
    headerName: 'Date of Inspection',
    field: 'inspectionDate',
    width: 140,
    minWidth: 140,
    type: 'dateColumn',
  },
  {
    headerName: 'RA Expiry Date',
    field: 'renewalDate',
    width: 130,
    minWidth: 130,
    type: 'dateColumn',
  },
  {
    headerName: '# Original Actions',
    field: 'noOfOriginalActions',
    width: 140,
    minWidth: 140,
  },
  {
    headerName: '# Outstanding Actions',
    field: 'noOfOutstandingActions',
    width: 160,
    minWidth: 160,
  },
  {
    headerName: 'Report Status',
    width: 120,
    minWidth: 120,
    valueGetter(params) {
      const { data } = params;

      const newerAssessments = data.historic;

      // At the moment only fire risk assessments have a renewal date
      // So we're only using 'Expired` for fire risk assessments
      if (
        data.assessmentType === PropertyAssessmentType.ASSESSMENT_TYPE_FIRE_RISK_ID() &&
        new Date(data.renewalDate) < new Date() &&
        !newerAssessments
      ) {
        return 'Expired';
      }

      if (data.rolledBack === 1 && (data.rolledBackTypeId === 2 || !data.rolledBackTypeId)) {
        return 'Rolled back';
      }

      if (data.rolledBack === 1 && data.rolledBackTypeId === 1) {
        return 'Withdrawn';
      }

      if (newerAssessments) {
        return 'Superseded';
      }

      return 'Current';
    },
  },
  {
    headerName: 'Rollback Reason',
    field: 'rollbackReason',
    width: 140,
    minWidth: 140,
    cellRendererFramework: TooltipComponent,
  },
  {
    headerName: '',
    field: '',
    width: 140,
    minWidth: 140,
    cellClass: 'overflow-cell',
    cellRendererFramework: DownloadReport,
  },
  {
    headerName: '',
    field: '',
    width: 150,
    minWidth: 150,
    cellClass: 'overflow-cell',
    cellRendererFramework: ShowPhotos,
  },
];
